export const maxLength = (maxCount: number) => {
  return (value?: string) => {
    if (typeof value !== 'string') {
      return null;
    }

    const countCharacters = value.length;

    if (countCharacters > maxCount) {
      return `Máximo de ${maxCount} caracteres`;
    }

    return null;
  };
};
